
define('text!common/views/membership-message.html',[],function () { return '<div id="site-message__message">\n    <div class="site-message__message site-message__message--membership">\n        <%=messageText%>\n    </div>\n    <a class="u-faux-block-link__overlay" target="_blank" href="<%=linkHref%>" data-link-name="Read more"></a>\n</div>\n';});

